// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container {
    background-color: rgba(0, 143, 199, 0.1);
    padding: 10px;
    border-radius: 5px;
    border: dashed 2px rgba(0, 143, 199, 0.3);
}

.preview-container p{
    width: 100%;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size:14px;
    color: rgba(0, 143, 199, 0.8);
}

.preview-container p span{
    color: rgba(0,0,0,.87);
}

.inputs-container{
    width:100%
}`, "",{"version":3,"sources":["webpack://./src/app/modules/content/add-edit-meta/add-edit-meta.component.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,aAAa;IACb,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;AACJ","sourcesContent":[".preview-container {\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    border: dashed 2px rgba(0, 143, 199, 0.3);\r\n}\r\n\r\n.preview-container p{\r\n    width: 100%;\r\n    overflow:hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    font-size:14px;\r\n    color: rgba(0, 143, 199, 0.8);\r\n}\r\n\r\n.preview-container p span{\r\n    color: rgba(0,0,0,.87);\r\n}\r\n\r\n.inputs-container{\r\n    width:100%\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
